export default [{
    path: '/order/order',
    name: 'order',
    component: () => import('@/projects/order/order'),
    meta: {
        title: '我的订单',
        index: 1,
        param: 'type=订单类型 ALL: "全部"  WAIT_PAY: "待付款"WAIT_ROG: "待收货"COMPLETE: "已完成"RETURN: "退款/售后"'
    }
},
{
    path: '/order/to_deliver',
    name: 'to_deliver',
    component: () => import('@/projects/order/to_deliver'),
    meta: {
        title: '待发货',
        index: 1,
    }
},
{
    path: '/order/returnOrderDetail',
    name: 'returnOrderDetail',
    component: () => import('@/projects/order/returnOrderDetail'),
    meta: {
        title: '售后订单',
        index: 1,
    }
},
{
    path: '/order/evaluate',
    name: 'evaluate',
    component: () => import('@/projects/order/evaluate'),
    meta: {
        title: '评价商品',
        index: 3,
    }
},
{
    path: '/order/afterOrder',
    name: 'afterOrder',
    component: () => import('@/projects/order/afterOrder'),
    meta: {
        title: '订单详情',
        index: 2,
    }
},
{
    path: '/order/returnOrder',
    name: 'returnOrder',
    component: () => import('@/projects/order/returnOrder'),
    meta: {
        title: '去退货',
        index: 3,
    }
},
{
    path: '/order/refund',
    name: 'refund',
    component: () => import('@/projects/order/refund'),
    meta: {
        title: '申请售后',
        index: 3,
    }
},
{
    path: '/order/logistics',
    name: 'logistics',
    component: () => import('@/projects/order/logistics'),
    meta: {
        title: '物流信息',
        index: 3,
    }
}
]


// WEBPACK FOOTER //
// ./src/projects/order/index.js